<template>
  <div style="margin-top: 15%;">
    <v-layout row>
      <v-flex lg8 />
      <v-flex xs12 md3 lg3 ml-3 mr-3 mb-2>
        <h3 style="font-size:20px;">ระบุสถิติที่ต้องการค้นหา</h3>
        <v-select
          :items="statlist"
          item-text="desc"
          item-value="value"
          v-model="topicID"
          @click="checkNull()"
          :menu-props="{ maxHeight: '400' }"
          v-on:input="RcodeList(), checkStatListLayer()"
        ></v-select>
      </v-flex>
    </v-layout>

    <v-layout row v-if="this.topicID != 'statage'">
      <v-flex lg8 />
      <v-flex xs12 md3 lg3 ml-3 mr-3 mb-2>
        <h3 style="font-size:20px;">ระบุปีที่ต้องการค้นหา</h3>
        <v-select
          :items="yearlist"
          item-text="year"
          item-value="value"
          v-model="yymm"
          @click="checkNull()"
          v-on:input="RcodeList()"
        ></v-select>
      </v-flex>
    </v-layout>
    <v-layout row >
      <v-flex lg8 />
      <v-flex xs12 md3 lg3 mt-2 text-xs-right ml-3>
        <v-btn
          small
          color="#10B1F7 "
          class="white--text"
          style="color:white;"
          @click="showValue()"
          >ค้นหา</v-btn
        >
        <v-btn small color="#10B1F7" style="color:white;" @click="reset()"
          >กลับหน้าเมนู</v-btn
        >
      </v-flex>
    </v-layout>

    <v-layout style="margin-top:10%">
      <v-flex lg7 />
      <v-flex xs12 md4 lg4 ml-4 mr-4 mb-4>
        <div style="color:red;font-size:20px">
          หมายเหตุก่อนปี 2556 มีเฉพาะผู้มีชื่ออยู่ในทะเบียนบ้านและมีสัญชาติไทย</div>
      </v-flex>
     
    </v-layout>
    
    <AlertBox ref="alertBox" />
    <dialogBox ref="dialogBox" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import jsoncc from "../json/cc.json";
import region from "../json/region.json";
import mm from "../json/mm.json";
import yy from "../json/yy.json";
import axios from "axios";
import genFunc from "../jsScript/CATMandRcode.js";

export default {
  data() {
    return {
      stattype: null,
      yymm: null,
      MonthLabel: "เดือนเริ่มต้น",
      YearLabel: "ปีเริ่มต้น",
      ShowtitleMonth: "ตั้งแต่ เดือน/ปี",
      alertBox: null,
      dialogBox: null,
      test01: "",
      checkbox: { chk1: false, chk2: false, chk3: false },
      radioGroup: 11,
      infoFilter: null,
      radioGroupScope: 11,
      switch1: true,
      selectMonth: { month: null, value: null },
      selectYear: { year: null },
      selectMonthEnd: { month: null, value: null },
      selectYearEnd: { year: null },
      GetSecArea: { val: null },
      GetScopeList: null,
      getCC: "",
      getRcode: "",
      getTT: "",
      getMM: "",
      jobLevel: null,
      aaaa: null,
      topicva: { val: null },
      getSection: null,
      getRegion: null,
      getCheckbox: null,
      statlist: [
        { desc: "สถิติจำนวนประชากรและบ้าน", value: "statpop" },
        { desc: "สถิติจำนวนประชากรแยกรายอายุ", value: "statage" },
        // {desc:'สถิติบ้าน',value:'stathouse'},
        { desc: "สถิติจำนวนการเกิด", value: "statbirth" },
        { desc: "สถิติจำนวนการตาย", value: "statdeath" },
        { desc: "สถิติจำนวนการตายรายอายุ", value: "statdeathAge" },
        { desc: "สถิติจำนวนการย้ายเข้า", value: "statmovein" },
        { desc: "สถิติจำนวนการย้ายออก", value: "statmoveout" },
      ],
      DataList: [
        { text: "ตรวจสอบข้อมูลแยกรายเดือน", val: 11 },
        { text: "ตรวจสอบข้อมูลแยกรายพื้นที่", val: 12 },
        // {text: 'ตรวจสอบข้อมูลแยกรายละเอียด', val: 13}
      ],
      TTItem: "",
      CCItem: jsoncc,
      RcodeItem: null,
      RegionItem: null,
      MMItem: null,
      months1: null,
      years1: null,
      months2: null,
      years2: null,
      ScopeList: [
        // {text: 'หมู่ที่', val: 56},
        { text: "ตำบล/แขวง", val: 55 },
        { text: "สำนักทะเบียน", val: 54 },
        { text: "จังหวัด", val: 53 },
        // {text: 'ภาค', val: 52},
        { text: "ประเทศ", val: 51 },
      ],
      titleText: null,
      topicID: null,
      getTTText: null,
      getMMText: null,
      yearlist: {},

      keepitem: {}
    };
  },

  created() {
    this.topicID = this.$route.params.id
    this.yymm = this.$route.params.bmmyyb
    this.yearlist = yy;
    
  },
  computed: {
  },
  methods: {
    ...mapActions({
      getVal: "StoreFilterVal/getVal",
      getCoin: "StoreFilterVal/getCoin",
    }),
    checkStatListLayer() {},
    showValue() {
      if (!this.topicID) {
        this.$refs.alertBox.showAlert(
          "กรุณาระบุสถิติที่ต้องการค้นหา",
          "warning",
          "แจ้งให้ทราบ"
        );
        return false;
      } else if (!this.yymm && this.topicID != "statage") {
        this.$refs.alertBox.showAlert(
          "กรุณาระบุปีที่ต้องการค้นหา",
          "warning",
          "แจ้งให้ทราบ"
        );
        return false;
      }
      let sendval = {
        titleText: this.titleText,
        action: this.GetScopeList,
        cc: this.getCC,
        rcode: this.getRcode,
        region: this.getRegion,
        tt: this.getTT,
        topicID: this.topicID,
        infoFilter: this.infoFilter,
        action: this.GetScopeList,
        yymm_b: this.yymm,
      };
      this.getVal(sendval);
      if (this.topicID != "statage") {
        this.$router.push({ path: `/TableTemplate/Area/${this.topicID}` });
      } else {
        this.$router.push({ path: `/FilterPageAge` });
      }
    },
    async RcodeList() {
      genFunc.getRcodebyCC(this.getCC).then((res) => {
        this.RcodeItem = res;
      });
    },
    reset() {
      window.location.href =
        "https://stat.bora.dopa.go.th/stat/statnew/statMenu/newStat/stat/";
    },
  },
  components: {},
};
document.documentElement.style.overflow = "hidden"; // firefox, chrome
document.body.scroll = "no"; // ie onlyo
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.v-text-field .v-label {
  width: auto;
  color: #030303;
  font-size: 20px;
  line-height: 26px;
  height: auto;
}
.select-label .v-select__selection {
  color: #000000;
  font-size: 16px;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.inputPrice input[type="number"] {
  -moz-appearance: textfield;
}
.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.6s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}
.text-no-border >>> .v-input__slot:before,
.text-no-border >>> .v-input__slot:after,
.text-no-border >>> input {
  border-style: none;
  margin-bottom: 0px;
}

.text-no-border1 >>> .v-input__slot:before,
.text-no-border1 >>> .v-input__slot:after,
.text-no-border1 >>> input {
  margin-bottom: 0px;
}

.text-to-label {
  padding-top: 0px;
}

.v-text-field .v-label {
  width: auto;
  color: black;
  font-size: 20px;
  line-height: 26px;
  height: auto;
}

@media (max-width: 768px) {
  .BG1 {
    background: url("../assets/1.png");
    padding-top: 50%;
    background-size: contain;
    background-repeat: no-repeat;
  }
}
</style>

:hint="`${selectMonthEnd.month}, ${selectMonthEnd.value}`" :to="{ name:
'TableTemplate' , params:{ } }"
